import ModalWrapper from '@Components/Modals/ModalWrapper/ModalWrapper';
import TaxStatusServices from '@Services/TaxStatus.services.ts';
import { TaxStatus } from '@Types/Asset.types';
import { handleRequestError } from '@Utils/request.utils';
import { ErrorDisplay, Toast } from '@kg-internal/pv3-uikit';
import { useState } from 'react';

type Props = {
  show: boolean;
  taxStatus?: TaxStatus;
  onClose: () => void;
  onSuccess: () => void;
};

const DeleteTaxStatus = ({ show, taxStatus, onClose, onSuccess }: Props) => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

  const deleteTaxStatus = () => {
    TaxStatusServices.disableTaxStatus(taxStatus?.id)
      .then(() => {
        Toast.success('Tax status deleted successfully.');
        onSuccess();
        onClose();
      })
      .catch((errorResponse) => handleRequestError(errorResponse, setErrorMessage, true));
  };

  return (
    <div className='modal--fit-content modal--w-30vw modal--pt-25vh'>
      <ModalWrapper
        title='Delete Tax Status'
        show={show}
        handleClose={onClose}
        primaryButtonText='Confirm'
        primaryAction={() => deleteTaxStatus()}>
        {errorMessage ? (
          <ErrorDisplay inline details={errorMessage} />
        ) : (
          <div>
            <p>
              <b>Description</b> : {taxStatus?.description}
            </p>
            <br />
          </div>
        )}
      </ModalWrapper>
    </div>
  );
};

export default DeleteTaxStatus;
